import axios from 'axios';
import { render } from 'app/app';
import { ajaxAppConfig, initApplication } from 'app/blocks/ajax/config/ajax-config';
import { injectDTM } from 'app/blocks/analytics/analytics';
import { l } from 'app/blocks/common/codes';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import { isEnabled } from 'app/blocks/common/storage';
import { showCriticalError } from 'app/blocks/error-boundary';
import { logout } from 'app/blocks/middleware/authentication';
import { isMock } from 'app/blocks/middleware/config';
import { toggleCodes, toggleFiles } from 'app/blocks/middleware/static';
import injectCRM from 'app/blocks/SupportWidget/external';

let isShowingExpiredDialog = false;
let isShowingOutdatedDialog = false;

ajaxAppConfig();

function thenReload(action) {
    return () => {
        action();
        window.location.reload();
    };
}

async function launchApp() {
    const error = await initApplication();
    if (error) {
        showCriticalError(error, true);
        return;
    }

    // @ts-ignore
    window.dotcmsToggleFiles = thenReload(toggleFiles);
    // @ts-ignore
    window.dotcmsToggleCodes = thenReload(toggleCodes);

    if (!isMock()) {
        if (!window._satellite) {
            injectDTM();
        }

        injectCRM();
    }

    if (!isEnabled()) {
        showDialog.modal(closeAnd => ({
            type: 'error',
            message: l('ERROR.LOCALSTORAGE_NOT_AVAILABLE'),
            closeBtnLabel: 'Reload',
            onClose: () => window.location.reload(),
            onIgnoreButtons: closeAnd(),
        }));
    }

    render();

    function showExpiredDialog() {
        if (!isShowingExpiredDialog) {
            showDialog.modal(closeAnd => ({
                type: 'error',
                pageid: 'Session Expired',
                message: l('ERROR.SESSION_HAS_BEEN_EXPIRED'),
                closeBtnLabel: 'Login',
                onClose() {
                    logout();
                    isShowingExpiredDialog = false;
                },
                onIgnoreButtons: closeAnd(() => {
                    logout();
                    isShowingExpiredDialog = false;
                }),
            }));

            logout(true);

            isShowingExpiredDialog = true;
        }
    }

    function showOutdatedDialog() {
        if (!isShowingOutdatedDialog) {
            showDialog.modal(closeAnd => ({
                type: 'error',
                message: l('ERROR.OUTDATED_CLIENT_SOFTWARE'),
                closeBtnLabel: 'Reload',
                onClose() {
                    window.location.reload();
                },
                onIgnoreButtons: closeAnd(() => {
                    isShowingOutdatedDialog = false;
                }),
            }));

            isShowingOutdatedDialog = true;
        }
    }

    axios.interceptors.response.use(response => {
        if (response.data.status === 'FAILURE') {
            const errorCode = response.data.error?.code;

            if (errorCode === 'UNAUTHORIZED' || errorCode === 'AUTH_COMMUNICATION_ERROR') {
                showExpiredDialog();
            } else if (errorCode === 'INCORRECT_CLIENT_VERSION') {
                showOutdatedDialog();
            }
        }

        return response;
    });
}

launchApp();
